import {
  Cargo,
  NormalizedCargo,
  NormalizedCargoItem,
  Route,
} from "../../domain/models/cargo-model";

export const normalizeCargo = (
  cargo: Cargo,
  date: string,
  warehouseId: number
): NormalizedCargo => {
  const {
    cargoReference: reference,
    orderReference,
    clientName,
    clientCpf,
    cep,
    neighborhood,
    additionalInformation,
    propertyNumber,
    street,
    referencePoint,
    city,
    federalUnit,
  } = cargo;

  const cargoItems: NormalizedCargoItem[] = [];

  cargo.cargoItems.map((item) => {
    if (item.batches && item.batches.length > 0) {
      item.batches?.map((batch) => {
        const newItem: NormalizedCargoItem = {
          reference: item.itemReference,
          productReference: item.productReference,
          eanCode: item.eanCode,
          productDescription: item.productDescription,
          invoiced: item.invoiced,
          batchReference: batch.batchReference,
          batch: batch.batch,
          amount: batch.amount,
          separatedAmount: 0,
        };
        cargoItems.push(newItem);
      });
    } else {
      const newItem: NormalizedCargoItem = {
        ...item,
        reference: item.itemReference,
        batchReference: "",
        batch: "",
        amount: item.totalAmount,
        separatedAmount: 0,
      };
      cargoItems.push(newItem);
    }
  });

  return {
    reference,
    orderReference,
    clientName,
    clientCpf,
    cep,
    neighborhood,
    additionalInformation,
    propertyNumber,
    street,
    referencePoint,
    city,
    federalUnit,
    cargoItems,
    date,
    warehouseId,
  };
};
